import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import axios from "axios";

// --- Global Axios Debug Logger ---
axios.interceptors.response.use(
  (response) => {
    // Berjalan sukses
    return response;
  },
  (error) => {
    // Tangkap error secara global dan tampilkan di console
    console.error("🔴 [AXIOS GLOBAL ERROR]:", {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      backendMessage: error.response?.data?.message || error.response?.data,
      axiosMessage: error.message
    });
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
